import DepositModal from './DepositModal';

export default DepositModal;



// WEBPACK FOOTER //
// ./src/components/DepositModal/index.js